import React, { useState, useEffect, useRef, useCallback } from "react";
import { Link } from "react-router-dom";
import { apiGet } from "../Utils/apiFetch";
import { apiPath } from "../Utils/apiPath";
import { levelMap } from "../Utils/Constant";

const DEBOUNCE_DELAY = 400;

const AllUser = () => {
  const [keyword, setKeyword] = useState("");
  const [users, setUsers] = useState([]);
  const debounceRef = useRef(null);
  const abortRef = useRef(null);

  const search = useCallback(async (searchKeyword) => {
    // cancel any in-flight request
    if (abortRef.current) abortRef.current.abort();
    const controller = new AbortController();
    abortRef.current = controller;

    try {
      const { status, data: response_users } = await apiGet(
        apiPath.searchUser,
        { keyword: searchKeyword },
        { signal: controller.signal },
      );
      if (status === 200 && response_users.success) {
        setUsers(response_users.results || []);
      }
    } catch (err) {
      if (err.name !== "AbortError") console.error(err);
    }
  }, []);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    if (!keyword.trim()) {
      setUsers([]); // optional: clear results when input is cleared
      return;
    }

    debounceRef.current = setTimeout(() => {
      search(keyword);
    }, DEBOUNCE_DELAY);

    return () => clearTimeout(debounceRef.current);
  }, [keyword, search]);
  const totalUsers = users.length;
  const totalPlayers = users.filter((u) => u?.userType === "user").length;
  const totalAdmin = totalUsers - totalPlayers;
  const totalOnline = users.filter((u) => u?.isOnline).length;

  return (
    <app-searchuser className="ng-star-inserted">
      <div className="main_wrap">
        <div className="function-wrap">
          <div
            className="box"
            style={{ backgroundColor: "#e0e6e6", lineHeight: "25px" }}
          >
            <div>
              <input
                type="text"
                name="userId"
                id="userId"
                placeholder="Find member..."
                className="search-input"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" && keyword.trim()) {
                    clearTimeout(debounceRef.current);
                    search(keyword);
                  }
                }}
              />
            </div>
            <div className="push">
              <button
                className="btn-send"
                onClick={() => {
                  if (!keyword.trim()) return; // skip if empty
                  clearTimeout(debounceRef.current);
                  search(keyword);
                }}
              >
                Refresh
              </button>
            </div>
          </div>
        </div>

        <div id="totalBox" className="total_box">
          <dl id="totalUsersDL" className="total_dl">
            <dt>Total Users</dt>
            <dd id="totalUsers"> {totalUsers} </dd>
          </dl>
          <dl
            id="totalAdminDL"
            className="total_dl"
            style={{ display: "block" }}
          >
            <dt>Total Admin</dt>
            <dd id="totalAdmin"> {totalAdmin} </dd>
          </dl>
          <dl id="totalPLayerDL" className="total_dl">
            <dt>Total Players</dt>
            <dd id="totalPLayer"> {totalPlayers} </dd>
          </dl>
          <dl id="totalOnlineDL" className="total_dl">
            <dt>Online Users</dt>
            <dd id="totalOnline"> {totalOnline} </dd>
          </dl>
        </div>
      </div>

      <cdk-virtual-scroll-viewport
        itemsize={18}
        className="cdk-virtual-scroll-viewport cdk-virtual-scroll-orientation-vertical"
        style={{ height: "80vh" }}
      >
        <div
          className="cdk-virtual-scroll-content-wrapper"
          style={{ transform: "translateY(0px)" }}
        >
          <div className="main_wrap">
            <div className="agent_path">
              <div className="table-responsive data-table">
                <table className="table01 table-pt">
                  <thead>
                    <tr>
                      <th
                        data-order="asc"
                        data-name="u"
                        rowSpan={2}
                        className="align-L sort_asc"
                      >
                        User Name
                      </th>
                      <th
                        data-order="asc"
                        data-name="n"
                        rowSpan={2}
                        className="align-L sort_asc"
                      >
                        Domain Name
                      </th>
                      <th rowSpan={2} className="align-L">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.length > 0 ? (
                      users.map((item, index) => (
                        <tr
                          key={item?._id || index}
                          className="ng-star-inserted"
                        >
                          <td className="align-L">
                            <span
                              className={`Bdlevel ${levelMap[item?.userType]} premium`}
                            />
                            {item?.username}{" "}
                          </td>
                          <td className="align-L">{item?.website || "-"} </td>
                          <td id="actionCol">
                            <ul style={{ border: "none" }} className="action">
                              <li>
                                <Link
                                  title="Account Summary"
                                  className="profile"
                                  id="profile"
                                  to={`/my-account/account-summary/${item?._id}/${item?.userType}`}
                                >
                                  Profile{" "}
                                </Link>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={3}>No records found</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="cdk-virtual-scroll-spacer" style={{ height: "18px" }} />
      </cdk-virtual-scroll-viewport>
    </app-searchuser>
  );
};

export default AllUser;
